import React from 'react';
import { TicketUiModel } from '../../../../shared/ui-models/ticket.ui-model';
import {
  CHIP,
  SLA_LABEL,
  SLA_STYLE,
  TARGET_LABEL,
  TARGET_STYLE,
  targetDetail
} from '../../../shared/ticket-visuals';

/**
 * The ticket against its SLA: first response and resolution, each with its due time and
 * when it was done. The due times are Zammad's, from the SLA matching the ticket's priority
 * and that SLA's calendar. First response = the team's first action on the ticket.
 */
export const TicketSla: React.FC<{ ticket: TicketUiModel; now?: number }> = ({ ticket, now }) => {
  const { sla } = ticket;
  const rows = [
    { name: 'First response', target: sla.firstResponse },
    { name: 'Resolution', target: sla.resolution }
  ];
  return (
    <section className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white p-4 shadow-md">
      <div className="flex items-center gap-2">
        <h2 className="font-gilroy-bold text-neutral-500">SLA</h2>
        <span className={`${CHIP} ${SLA_STYLE[sla.state]}`}>{SLA_LABEL[sla.state]}</span>
      </div>
      {sla.state === 'none' ? (
        <p className="text-sm text-neutral-400">No SLA applies to this ticket.</p>
      ) : (
        rows.map(({ name, target }) => (
          <div key={name} className="flex flex-col gap-1">
            <div className="flex items-center justify-between gap-2 text-sm text-neutral-500">
              {name}
              <span className={`${CHIP} ${TARGET_STYLE[target.state]}`}>
                {TARGET_LABEL[target.state]}
              </span>
            </div>
            <p className="text-xs text-neutral-400">{targetDetail(target, now)}</p>
          </div>
        ))
      )}
    </section>
  );
};
